import { CompanySearchFilter } from '../../models/companySearchFilter';

export interface ICompanyListState {
  searchFilter: CompanySearchFilter;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

// `measurement` is intentionally omitted: the active business year is unknown at module-load time
// (the JS bundle parses before provideAppInitializer runs). The list component fills it in from
// the live ActiveYearService value on first load, then the store carries the user's selection.
export const initialCompanyListState: ICompanyListState = {
  searchFilter: { isActive: true },
  currentPage: 1,
  pageSize: 10,
  sortBy: 'companyName',
  ascending: true
};
